import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize, TextType} from '@Components/text';
import type {StockPanelRecentSearchesDropdownProps} from './stock-panel-recent-searches-dropdown.types';
import styles from './stock-panel-recent-searches-dropdown.module.scss';

export function StockPanelRecentSearchesDropdown({searchTerms, onClear, onTermClick}: StockPanelRecentSearchesDropdownProps): ReactElement {
  const getSearchTermRow = (term: string): ReactElement => {
    return (
      <ClickableDiv
        key={term}
        className={styles.searchTermRow}
        onClick={(): void => {
          onTermClick(term);
        }}
      >
        <Icon icon="icon-history" size={IconSize.SIZE_ICON_16} className={styles.historyIcon} />
        <span className={styles.searchTermText}>{term}</span>
      </ClickableDiv>
    );
  };

  return (
    <div className={'flex-v-row gap-1 spacing-p-4'}>
      <div className={'flexbox flex-items-center flex-justify-between'}>
        <span className={styles.title}>{window.i18next.t('pmwjs_recents')}</span>
        <Text className={styles.clearButton} val={window.i18next.t('pmwjs_clear')} type={TextType.BODY} size={TextSize.XSMALL} onClick={onClear} bold />
      </div>
      {searchTerms.map(getSearchTermRow)}
    </div>
  );
}
